import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  testPaymentInformationPaymentAcceptedCv,
  testPaymentInformationPaymentAcceptedIb,
  testPaymentInformationPaymentTicketed,
  testPaymentInformationPaymentUnpurchased,
  testPaymentInformationPaymentUnticketed,
} from '@app/test-ssn/testData/booking-completed/booking-completed-test-data';
import { DeliveryInformationStoreService } from '@common/services';
import { RoutesResRoutes } from '@conf/routes.config';
import { SupportComponent, SupportModalBlockComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-booking-completed-test',
  templateUrl: './booking-completed-test.component.html',
  styleUrls: ['./booking-completed-test.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class bookingCompletedTestComponent extends SupportComponent implements OnInit {
  public text = '';

  reload(): void {}
  init(): void {}
  destroy(): void {}

  constructor(
    private _common: CommonLibService,
    private _router: Router,
    private _deliveryInformationStoreService: DeliveryInformationStoreService
  ) {
    super(_common);
  }

  bookingCompletedTest1() {
    this._router.navigateByUrl(RoutesResRoutes.BOOKING_COMPLETED);
  }

  bookingCompletedTestTicketed() {
    this._deliveryInformationStoreService.setDeliveryInformation({
      paymentInformation: testPaymentInformationPaymentTicketed,
    });
    this._router.navigateByUrl(RoutesResRoutes.BOOKING_COMPLETED);
  }

  bookingCompletedTestUnticketed() {
    this._deliveryInformationStoreService.setDeliveryInformation({
      paymentInformation: testPaymentInformationPaymentUnticketed,
    });
    this._router.navigateByUrl(RoutesResRoutes.BOOKING_COMPLETED);
  }

  bookingCompletedTestUnpurchased() {
    this._deliveryInformationStoreService.setDeliveryInformation({
      paymentInformation: testPaymentInformationPaymentUnpurchased,
    });
    this._router.navigateByUrl(RoutesResRoutes.BOOKING_COMPLETED);
  }

  bookingCompletedTestAcceptedCv() {
    this._deliveryInformationStoreService.setDeliveryInformation({
      paymentInformation: testPaymentInformationPaymentAcceptedCv,
    });
    this._router.navigateByUrl(RoutesResRoutes.BOOKING_COMPLETED);
  }

  bookingCompletedTestAcceptedIb() {
    this._deliveryInformationStoreService.setDeliveryInformation({
      paymentInformation: testPaymentInformationPaymentAcceptedIb,
    });
    this._router.navigateByUrl(RoutesResRoutes.BOOKING_COMPLETED);
  }
}
